import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

/**
 * Linaria styles for IndexRow.
 *
 * IndexRow.Item renders into NakedButton by default, which sets `background: none`
 * and `border: none`. The item below intentionally uses the SAME `background`/`border`
 * shorthands, so @linaria/atomic's `cx` de-dupes them by property and the item's
 * declarations (composed last) win deterministically — no shorthand/longhand tie.
 * The hover override uses `background-color` (a longhand → atomic priority 2) so it
 * beats the base `background`.
 */

export const rowItemBaseStyle = css`
  padding: ${theme.spacing(1)};
  display: flex;
  min-height: 40px;
  width: 100%;
  background: ${theme.colors.white};
  align-items: center;
  border: 1px solid ${theme.colors.neutral20};
  transition: background 0.2s ease;
  text-decoration: none;
  color: ${theme.colors.neutral70};

  &:not(:first-child) {
    border-top: none;
  }

  &:first-child {
    border-radius: ${theme.borderRadius.small} ${theme.borderRadius.small} 0 0;
  }

  &:last-child {
    border-radius: 0 0 ${theme.borderRadius.small} ${theme.borderRadius.small};
  }

  &:only-child {
    border-radius: ${theme.borderRadius.small};
  }
`;

export const rowItemDisabledStyle = css`
  background: ${theme.colors.neutral10};
  cursor: default;
`;

export const rowItemInteractiveStyle = css`
  &:hover {
    background-color: ${theme.colors.neutral5};
  }
`;

export const rowItemContentStyle = css`
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  gap: ${theme.spacing(3)};
  margin-right: ${theme.spacing(2)};
`;

export const caretStyle = css`
  margin-left: auto;
`;

export const marginLeftAutoStyle = css`
  margin-left: auto;
`;

export const truncatedTextStyle = css`
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const noMarginStyle = css`
  margin: 0;
`;

export const halfOpacityStyle = css`
  opacity: 0.5;
`;

export const helperTextContainerStyle = css`
  padding: ${theme.spacing(1)};
`;
